import { useContext, useEffect, useState } from 'react';
import styles from './SideMenu.module.css';
import ConnUrls from '../Connections/ConnectURL';
import { useNavigate } from 'react-router-dom';
import { SideMenuContext } from '../Contexts/SideMenu_Context';
import { SpecialUserContext } from '../Contexts/SpecialUser_Context';

const SPUseSet = (props) => {
    const [specialUser, setSpecialUser] = useContext(SpecialUserContext);
    const [erMsg, setErMsg] = useState("");

    const [fName, setFName] = useState("");
    const [lName, setLName] = useState("");
    const [phoneNum, setPhoneNum] = useState("");
    const [email, setEmail] = useState("");

    useEffect(() => {
    }, [specialUser]);

    useEffect(() => {
        if (specialUser) {
            setFName(specialUser.firstName)
            setLName(specialUser.lastName)
            setPhoneNum(specialUser.phone)
            setEmail(specialUser.email)
        }
    }, []);

    const saveSpecialUser = () => {
        if (fName !== "" && fName !== null &&
            lName !== "" && lName !== null &&
            phoneNum !== "" && phoneNum !== null &&
            email !== "" && email !== null) {
            setSpecialUser({
                firstName: fName,
                lastName: lName,
                phone: phoneNum,
                email: email,
            })
            props.closePop();
        }
        else {
            setErMsg("יש למלא את כל הפרטים")
        }

    }

    const clearSpecialUser = () => {
        setFName("")
        setLName("")
        setPhoneNum("")
        setEmail("")
        setSpecialUser();
    }


    return (
        <>
            <div className={"claerlineSpacer"}></div>
            <div className={"claerlineSpacer"}></div>

            <div className={styles.contWrap}>
                <input
                    id={"nameEnter"}
                    className={`${styles.GoSendData} ${erMsg.includes("שם פרטי") ? "errorInput" : ""}`}
                    placeholder={"שם פרטי"} value={fName}
                    onChange={(e) => setFName(e.target.value)}
                    label="שם פרטי" variant="filled"
                />
            </div>
            <div className={styles.contWrap}>
                <input className={`${styles.GoSendData} ${erMsg.includes("שם משפחה") ? "errorInput" : ""}`}
                    placeholder={"שם משפחה"} value={lName}
                    onChange={(e) => setLName(e.target.value)} label="שם משפחה" variant="filled" />
            </div>
            <div className={styles.contWrap}>
                <input
                    className={`${styles.GoSendData} ${erMsg.includes("טלפון") ? "errorInput" : ""}`}
                    placeholder={"נייד (לקבלת SMS)"} value={phoneNum} onChange={(e) =>
                        setPhoneNum(e.target.value)} label="נייד (לקבלת SMS)" variant="filled" />
            </div>
            <div className={styles.contWrap}>
                <input
                    className={`${styles.GoSendData} ${erMsg.includes("מייל") ? "errorInput" : ""}`}
                    placeholder={"מייל"} value={email} onChange={(e) =>
                        setEmail(e.target.value)} label="מייל" variant="filled" />
            </div>
            <div className={styles.contWrap}>
                <div className={`${styles.loginPageBtns} inColorWhite inBackBlue pointing`} onClick={() => saveSpecialUser()}>
                    <div>אישור</div>
                </div>
                <div className={"fullRow errorLine bold"}>
                    <p className={"noMargin"}>
                        {erMsg !== "" ? erMsg :
                            erMsg !== "" ? "יש למלא את כל הפרטים המסומנים" : ""
                        }
                    </p>
                </div>
            </div>

            <div className={`${styles.loginPageBtns} inColorWhite inBackBlue pointing`} onClick={() => clearSpecialUser()}>
                <div>נקה נתונים</div>
            </div>

        </>
    );
}

export default SPUseSet;
